module.exports = __webpack_public_path__ + "assets/img/register-v2-dark.129e616a.svg";